export const templateSections = {
  information: {
    title: 'Document Information',
    items: [
      {
        display: 'inline',
        key: 'owner',
        label: 'Document Owner',
        options: [
          { label: 'MGT', value: 'MGT' },
          { label: 'QA/QC', value: 'QA/QC' },
          { label: 'Q&W', value: 'Q&W' },
          { label: 'T&H', value: 'T&H' },
        ],
        required: true,
        type: 'select',
      },
      {
        display: 'inline',
        key: 'documentType',
        label: 'Document Type',
        placeholder: 'Quality Manual (QM)',
        required: true,
        type: 'static',
      },
      {
        display: 'inline',
        key: 'serial',
        label: 'Document Number',
        placeholder: 'Generated after save',
        required: true,
        type: 'static',
      },
      {
        display: 'inline',
        key: 'effectiveDate',
        label: 'Effective Date',
        placeholder: 'DD-MMM-YYYY',
        required: true,
        type: 'static',
      },
      {
        display: 'inline',
        key: 'nextPeriodReviewDate',
        label: 'Next Periodic Review Date',
        placeholder: 'DD-MMM-YYYY',
        required: true,
        type: 'static',
      },
      {
        display: 'inline',
        key: 'issueDate',
        label: 'Original Issue Date',
        placeholder: 'DD-MMM-YYYY',
        required: false,
        type: 'static',
      },
      {
        display: 'inline',
        key: 'documentNumber',
        label: 'Document Code',
        placeholder: 'QM-GG1456-001',
        required: true,
        type: 'text',
      },
      {
        display: 'inline',
        key: 'documentTitle',
        label: 'Document Title',
        placeholder:
          'Identification of nonconformity, root cause analysis, investigation, corrective and preventive action, and continuous improvement',
        required: true,
        type: 'textarea',
      },
      {
        key: 'division',
        label: 'Division / Group / Branch / Unit',
        required: false,
        type: 'textarea',
      },
      {
        key: 'controlCopy',
        label: 'Control Copy Statement',
        required: false,
        type: 'static',
      },
      {
        key: 'confidentiality',
        label: 'Confidentiality Statement',
        required: false,
        type: 'static',
      },
    ],
  },
  history: {
    title: 'Document History & Approval',
    items: [
      { key: 'dCCNumber', label: 'CC Number', required: true, type: 'text' },
      {
        key: 'revisionNumber',
        label: 'Revision Number',
        required: true,
        type: 'text',
      },
      {
        key: 'summaryOfChange',
        label: 'Summary of Change',
        required: true,
        type: 'text',
      },
      {
        key: 'preparedBy',
        label: 'Prepared By',
        required: false,
        type: 'text',
      },
      {
        key: 'reviewedBy',
        label: 'Reviewed By',
        required: false,
        type: 'text',
      },
      {
        key: 'approvedBy',
        label: 'Approved By',
        required: false,
        type: 'text',
      },
    ],
  },
  content: {
    title: 'Content',
    items: [
      {
        key: 'objectiveAndScope',
        label: 'Objective and Scope',
        required: false,
        type: 'complex',
      },
      {
        key: 'terms',
        label: 'Terms & Definitions',
        required: false,
        type: 'complex',
      },
      {
        key: 'references',
        label: 'References',
        required: false,
        type: 'complex',
      },
      {
        key: 'responsibilities',
        label: 'Responsibilities',
        required: false,
        type: 'complex',
      },
      {
        key: 'clauseDetails',
        label: 'Clause Details',
        required: true,
        type: 'complex',
      },
      { key: 'appendix', label: 'Appendix', required: false, type: 'complex' },
    ],
  },
};

// Get all field keys for a section
export const getSectionFields = (sectionKey) => {
  const section = templateSections[sectionKey];
  if (!section) return [];

  return [...section.items.map((field) => field.key)];
};

// Get all optional field keys for a section
export const getSectionOptionalFields = (sectionKey) => {
  const section = templateSections[sectionKey];
  if (!section) return [];

  return section.items
    .filter(({ required }) => !required)
    .map((field) => field.key);
};
